import Layout from '../../layout'
import TabelTestimonial from './components/Table'
import { useEffect, useState } from 'react'

// REDUX
import { useDispatch, useSelector } from 'react-redux'
import { selectCurrentUser } from '../../redux/user/user.selectors'
import { removeCurrentUser } from '../../redux/user/user.action'

import FetchLoading from '../../components/FetchLoading'
import ButtonLink from '../../components/ButtonLink'
import axios from 'axios'
import { message } from 'antd'
import { useNavigate } from 'react-router-dom'

const Testimonial = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const currentUser = useSelector(selectCurrentUser)
  const [testimonials, setTestimonials] = useState(null)

  useEffect(() => {
    axios({
      method: 'get',
      url: '/testimonial',
      headers: {
        Authorization: `Bearer ${currentUser.token}`,
      },
    })
      .then(({ data }) => {
        setTestimonials(data[0])
      })
      .catch((error) => {
        if (error.response.status === 404) {
          message.error('404 Not Found')
        }
        if (error.response.status === 401) {
          message.error('401 Unauthorized')
          dispatch(removeCurrentUser())
          navigate('/login')
        }
        if (error.response.status === 500) {
          message.error('500 Internal Server Error')
        }
        if (error.response.status === 403) {
          message.error('403 Forbidden')
        }
      })
  }, [currentUser.token, dispatch, navigate])

  return (
    <Layout id="testimonial" title="Testimoni">
      <ButtonLink
        urlRoute="/testimoni/testimoni-tambah"
        title="Tambah Testimoni"
      />
      <FetchLoading data={testimonials}>
        <TabelTestimonial testimonials={testimonials}></TabelTestimonial>
      </FetchLoading>
    </Layout>
  )
}

export default Testimonial
